import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const BlogItem = (props) => {
  const { image, title, description, link } = props.blog;

  return (
    <div className="w-full lg:w-1/2 p-2 md:p-3">
      <Link to={link} className="group h-full block">
        <div className="relative rounded-2xl overflow-hidden h-full transition-all duration-300">
          {/* Glass container */}
          <div className="absolute inset-0 bg-white/70 backdrop-blur-md rounded-2xl" />

          {/* Border gradient */}
          <div className="absolute inset-0 rounded-2xl p-[2px] bg-gradient-to-br from-green-400/30 to-blue-400/20" />

          {/* Content wrapper */}
          <div className="relative z-10 rounded-2xl border border-white/40 overflow-hidden h-full flex flex-col">
            {/* Image section */}
            <div className="relative h-48 overflow-hidden">
              <img
                src={image}
                alt={title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              {/* Accent overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-gray-900/30 group-hover:to-green-900/40 transition-all duration-300" />
              {/* Top accent line */}
              <div className="absolute top-0 left-0 w-1 h-12 bg-gradient-to-b from-green-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>

            {/* Text content */}
            <div className="flex-1 p-5 md:p-6 flex flex-col">
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-green-600 transition-colors">
                {title}
              </h3>
              <p className="text-sm text-gray-700 line-clamp-3 mb-4 flex-grow">
                {description}
              </p>

              {/* Read more button */}
              <div className="inline-flex items-center gap-2 text-sm font-semibold text-green-600 group-hover:text-green-700 transition-colors">
                <span>Read More</span>
                <FaArrowRight className="opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300" />
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BlogItem;
